import {
  Component,
  inject,
  OnInit,
  signal,
  WritableSignal,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MenuItemsServiceService } from '../../Services/menu-items.service.service';
import { SingleMenuItem } from '../../models/Customer Order model/single-menu-item.model';
import { LanguageService } from '../../Services/language.service';
import { CouponService } from '../../Services/coupon.service';

@Component({
  selector: 'app-page-single-menu-item-user',
  templateUrl: './page-single-menu-item-user.component.html',
  styleUrl: './page-single-menu-item-user.component.scss',
})
export class PageSingleMenuItemUserComponent implements OnInit {
  //services
  MenuItemService = inject(MenuItemsServiceService);

  menuItemID!: number;
  Menuitem!: SingleMenuItem;

  MenuTitle: WritableSignal<string> = signal('');
  private languageService = inject(LanguageService);
  private CouponService = inject(CouponService);
  language = this.languageService.getLanguage();
  hasCoupon = false;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.menuItemID = +this.route.snapshot.paramMap.get('id')!;
    this.callMenuItems();
    this.updateTitles();
    this.checkItemCouponExist();
  }
  callMenuItems() {
    this.MenuItemService.getMenuItem(this.menuItemID).subscribe({
      next: (response) => {
       // console.log(response);
        this.Menuitem = response;
      },
    });
  }

  private updateTitles() {
    // Update titles based on the current language in the service
    this.MenuTitle = this.languageService.MenuPageTitle;
  }

  checkItemCouponExist(): void {
    this.CouponService.checkMenuItemCoupon(this.menuItemID).subscribe({
      next: (response) => {
        if (typeof response === 'number' && response >= 0) {
          this.hasCoupon = true;
         // console.log(`Coupon Exists for item ${this.menuItemID}: ${response}`);
        } else {
          this.hasCoupon = false;          
        //  console.log(`No Coupon for item ${this.menuItemID}`);
        }
      },
      error: (err) => {
        console.error(`Error checking coupon for item ${this.menuItemID}:`, err);
        this.hasCoupon = false; // Assume no coupon on error
      },
    });
  }
}
